import Bowser from 'bowser';
import logger from 'src/utils/logger';

import {isMobile} from 'src/utils/responsive';


export type ChameleonSource = 'web' | 'extension' | 'mobile' | 'unknown';

export type ChameleonDeviceTraits = {
  deviceType: string;
  browser: string;
  operatingSystem: string;
  country: string;
  source: ChameleonSource;
};

function getChameleonSource(
  context: string | null | undefined,
): ChameleonSource {
  try {
    if (context === 'chrome-extension') {
      return 'extension';
    }
    if (typeof navigator !== 'undefined' && isMobile(navigator.userAgent)) {
      return 'mobile';
    }
    return 'web';
  } catch (error) {
    logger.error('Error getting chameleon source', error);
    return 'unknown';
  }
}

function getBrowserTimezone(fallback: string): string {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone) {
      return timeZone;
    }
  } catch (error) {
    logger.error('Error getting browser timezone', error);
  }
  return fallback;
}

export function getChameleonDeviceTraits(
  context: string | null | undefined,
): ChameleonDeviceTraits {
  const defaults: ChameleonDeviceTraits = {
    deviceType: 'unknown',
    browser: 'unknown',
    operatingSystem: 'unknown',
    country: 'unknown',
    source: getChameleonSource(context),
  };
  try {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const parser = Bowser.getParser(ua);
    const platformType = parser.getPlatformType();
    const browserObj = parser.getBrowser();
    const osObj = parser.getOS();
    return {
      deviceType: platformType ?? defaults.deviceType,
      browser: browserObj.name ?? defaults.browser,
      operatingSystem: osObj.name ?? defaults.operatingSystem,
      country: getBrowserTimezone(defaults.country),
      source: defaults.source,
    };
  } catch {
    return defaults;
  }
}
